module.exports = __webpack_public_path__ + "8b8b0978c6baf50183361affafe2f84e.MP3";